// extracted by mini-css-extract-plugin
module.exports = {"comp":"BannerB_comp__TlwqJ"};